import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { selectToken } from './authSlice';
import Cookies from 'js-cookie';


const API_BASE_URL = process.env.REACT_APP_API_URL||"https://bookingserver.texascenterwellness.com/"

const getTokenFromCookies = () => {
  return Cookies.get('token');
};

export const loginApi = createApi({
  reducerPath: 'loginApi',
  baseQuery: fetchBaseQuery({
    baseUrl: API_BASE_URL,
    tagTypes:["Login"],

    prepareHeaders: (headers, { getState }) => {
      const token = selectToken(getState()) || getTokenFromCookies();

      if (token) {
        headers.set('Authorization', `${token}`);
      }

      return headers;
    },
    providesTags:["Login"]

  }),
  endpoints: (builder) => ({
    getmeApi: builder.query({
      query: () => '/AdminRoutes/me',
      providesTags:["Login"]

    }),
    login: builder.mutation({
      query: (values) => ({
        url: '/AdminRoutes/LoginAdmin',
        method: 'POST',
        body: values,
      }),
      invalidatesTags: ["Login"],
    }),
    forgetpassword: builder.mutation({
      query: (values) => ({
        url: '/UserRoutes/AdminForgotPassword',
        method: 'POST',
        body: values,
      }),
    }),
    confirmpassword: builder.mutation({
      query: (values) => ({
        url: '/AdminRoutes/ConfirmCode',
        method: 'POST',
        body: values,
      }),
    }),
    resetpassword: builder.mutation({
      query: ({id ,values}) => ({
        url: `/UserRoutes/AdminResetPassword/${id}`,
        method: 'POST',
        body: values,
      }),
    })

  }),
});

export const {
  useGetmeApiQuery,
  useLoginMutation,
  useForgetpasswordMutation,
  useConfirmpasswordMutation,
  useResetpasswordMutation,
} = loginApi;